<template>
  <div>
    <div v-if="citationFeature">
      <div v-if="citations.length > 0">
        <div class="card-header" id="citationsheaderid">
          <togglable-caret-header data-bs-toggle="collapse" class="header__link" :data-bs-target="'#collapsecitations'" :showCaret="true">
            <a role="button">Citations</a>
          </togglable-caret-header>
        </div>
        <div id="collapsecitations" class="collapse">
          <item-detail :keywords="keywords" :item="citationsAsItem()" :type="'citation'"/>
        </div>
      </div>
    </div>
    <div v-for="(dateContents, dateAsKey, i) in activities" :key="npi+'_'+i" >
      <div v-if="Object.keys(dateContents).length > 0">
          <!-- date header -->
          <div class="card-header" :id="dateAsKey">
              <togglable-caret-header
                data-bs-toggle="collapse"
                class="header__link"
                :data-bs-target="'#collapse'+i"
                :showCaret="true"
              >
                <a role="button">
                  {{ dateAsKey }}
                </a>
              </togglable-caret-header>
          </div>

          <!-- kinds: med, report, proc -->
          <div :id="'collapse'+i" class="collapse">
              <ul class="list-group w-100">
                <li v-for="(groupedEntries, kind, j) in dateContents['kind']" :key="kind+j" class="list-group-item">
                  <ul class="list-group w-100">
                    <strong>{{ getHeaderByKind(kind) }}</strong>

                    <li v-for="(groupedEntry,iEntry) in groupedEntries" :key="kind+iEntry">
			<item-detail :keywords="keywords" :item="groupedEntry" :type="kindExpanded(kind)"/>  
		    </li>
<!--
                    <div>{{ dump(groupedEntry) }}</div>
			<div v-for="(id,iId) in groupedEntry.ids" :key="id+'x'+iId">
		   <div>{{ dump('start here2') }}</div>
				CDA {{ dump(iId) }}
				CDA {{ dump(id) }}
				CDA {{ groupedEntry.cdas[iId] }}
				CDA {{ kind }}
				CDA {{ cdaList[getCdaIndexById(allData,groupedEntry.cdas[iId])] }}
		   <div>{{ dump('start here3') }}</div>
			</div>
                    <div>{{ getActivityDescByKindAndId(kind, groupedEntry.ids[0]) }}</div>
		    </li>
                    <li v-for="(idInKind, k) in idsInKind" :key="kind+j+'_id'+k" class="list-group-item">
                      {{getActivityDescByKindAndId(kind, idInKind)}}
                      <! -- NOTE/TODO: if allData.reports uses id as index, then use idInKind directly -- >
                      <router-link v-if="kind === kinds.REPORT" :to="{ name: 'ReportsNavigation', params: { index: idInKind, fileType: REPORT_FILE_TYPE } }" class="float-right">View report</router-link>
                    </li>
-->

                  </ul>
                </li>
              </ul>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import {
  getDescByKindAndId
} from '@/data/getters';
import { 
  REPORT_FILE_TYPE,
  FEATURES
} from '@/config';
import TogglableCaretHeader from '@/components/includes/TogglableCaretHeader';
import { getDescByCcd, getCdaIndexById } from '@/data/getters.js';
import ItemDetailPage from '@/components/includes/ItemDetailPage';


import kinds from '@/constants/kinds';
import {
  getHeaderByKind
} from '@/data/getters';

export default {
  name: 'provider-activities',
  components: {
    'togglable-caret-header': TogglableCaretHeader,
    'item-detail':ItemDetailPage
  },
  props: {
    activities: Object,
    citations: null,
    npi: null
  },
  data() {
    return {
      kinds,
      REPORT_FILE_TYPE,
      keywords: []
    };
  },
  computed: {
    ...mapGetters('login', {
      allData: 'getAllData',
    }),
    ...mapGetters('login/cda', {
      cdaList: 'getCdaList'
    }),
    citationFeature() {
	    return !!FEATURES.cda_header_providers;
  },
},
  beforeDestroy() {
    delete this.kinds;
    this.kinds = null;
    delete this.REPORT_FILE_TYPE;
    this.REPORT_FILE_TYPE = null;
    
  },
  methods: {
    citationsAsItem() {
      return {
        cdas : this.citations
      };
    },
    dump(o) {
      let s = JSON.stringify(o);
      return s;
    },
    getCdaIndexById,
    getActivityDescByKindAndId(kind, id) {
      return getDescByKindAndId(kind, id, this.allData).toLowerCase();
    },
    getHeaderByKind,
    kindExpanded(key) {
      let result = '';
      Object.keys(kinds).forEach((s) => {
        if(kinds[s] == key)
          result = s;
      });
      return result;
    }
  }
}
</script>
